import { render } from "./JourneyVehicle.vue?vue&type=template&id=00d791e2"
import script from "./JourneyVehicle.vue?vue&type=script&lang=js"
export * from "./JourneyVehicle.vue?vue&type=script&lang=js"
script.render = render

export default script